import { type CSSProperties, type ReactElement } from 'react';
import wordmarkInk from '@vello/brand/assets/wordmark/svg/vello-wordmark-ink.svg';
import wordmarkWhite from '@vello/brand/assets/wordmark/svg/vello-wordmark-branco.svg';
import markOnLight from '@vello/brand/assets/simbolo/svg/vello-mark-on-light.svg';
import markWhite from '@vello/brand/assets/simbolo/svg/vello-mark-branco.svg';

/**
 * Vello brand marks for the operator console, rendered from the approved `@vello/brand` assets (the single
 * source for the wordmark/symbol) — never a recomposed or ad-hoc SVG. The console is a light surface and the
 * authoritative Claude Design login (Admin Web.dc.html A01) uses the **ink** wordmark + the **on-light** mark,
 * so those are the variants used here. Importing the SVG as a URL keeps every brand color inside the asset
 * file (no hex in app code — the `check:visual` gate stays green).
 */

/** The approved Vello wordmark, sized by height (aspect preserved). */
export function Wordmark({ height = 26, title = 'Vello', style }: { height?: number; title?: string; style?: CSSProperties }): ReactElement {
  return <img src={wordmarkInk} alt={title} style={{ height, width: 'auto', display: 'block', ...style }} />;
}

/** The approved white wordmark for a dark/navy surface (the showcase sign-in panel — brand rule: dark surface → white). */
export function WordmarkOnDark({ height = 26, title = 'Vello', style }: { height?: number; title?: string; style?: CSSProperties }): ReactElement {
  return <img src={wordmarkWhite} alt={title} style={{ height, width: 'auto', display: 'block', ...style }} />;
}

/** The approved Vello symbol/mark, square. */
export function Mark({ size = 28, title = 'Vello', style }: { size?: number; title?: string; style?: CSSProperties }): ReactElement {
  return <img src={markOnLight} alt={title} style={{ height: size, width: size, display: 'block', ...style }} />;
}

/** The approved white mark for a dark/navy surface (the web shell's sidebar — brand rule: dark surface → white). */
export function MarkOnDark({ size = 26, title = 'Vello', style }: { size?: number; title?: string; style?: CSSProperties }): ReactElement {
  return <img src={markWhite} alt={title} style={{ height: size, width: size, display: 'block', ...style }} />;
}
